export const GLOBAL_MENU_CHANGE = 'GLOBAL_MENU_CHANGE';
export const GLOBAL_RESTAURANT_VERSION = 'GLOBAL_RESTAURANT_VERSION';
export const GLOBAL_WORKING_TIME = 'GLOBAL_WORKING_TIME';

export const PRIVATE_RELOAD_CUSTOMER_DETAILS = 'PRIVATE_RELOAD_CUSTOMER_DETAILS';
export const PRIVATE_ORDER_UPDATE = 'PRIVATE_ORDER_UPDATE';
export const PRIVATE_MENU_CHANGE = 'PRIVATE_MENU_CHANGE';
export const PRIVATE_CUSTOMER_GROUP = 'PRIVATE_CUSTOMER_GROUP';
